import Box from "@/common/components/Box";
import Button from "@/common/components/Button";
import ResumeItem from "@/common/components/ResumeItem";
import { formatCurrency } from "@/common/utils/formatters";
import { SquareArrowOutUpRightIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { CompanyData } from "../../types/company.type";
import useCompanyRemainingCreditAndBalance from "@/common/hooks/queries/useCompanyRemainingCreditAndBalance";
import useUserPermissions from "@/common/hooks/useUserPermissions";

interface CompanyBankingDepositDashboardProps {
  company: CompanyData | undefined;
}

const CompanyBankingDepositDashboard = ({ company }: CompanyBankingDepositDashboardProps) => {
  const {
    data: companyRemainingCreditAndBalance,
    isPending: isCompanyRemainingCreditAndBalancePending,
  } = useCompanyRemainingCreditAndBalance();

  const { hasUserPermission, isUserPermissionsPending } = useUserPermissions();

  const hasUserPermissionToGetCompanyRemainingCreditAndBalance = hasUserPermission("Client::Companies::RemainingCreditAndBalance");

  if (company?.kind !== "private_company") {
    return null;
  }

  if (!isUserPermissionsPending && !hasUserPermissionToGetCompanyRemainingCreditAndBalance) {
    return null;
  }

  return (
    <Box className='bg-white-200 p-4 flex items-center justify-between'>
      <div className='flex lg:flex-row flex-col lg:items-center gap-3'>
        <ResumeItem
          className='text-valid'
          label="Saldo disponível (Pré-pago)"
          value={companyRemainingCreditAndBalance?.remaining_balance
            ? formatCurrency(Number(companyRemainingCreditAndBalance?.remaining_balance))
            : '--'}
          isLoading={isCompanyRemainingCreditAndBalancePending}
        />

        <ResumeItem
          className='text-yellow-400'
          label="Crédito disponível (Pós-pago)"
          value={companyRemainingCreditAndBalance?.remaining_credit
            ? formatCurrency(Number(companyRemainingCreditAndBalance?.remaining_credit))
            : '--'}
          isLoading={isCompanyRemainingCreditAndBalancePending}
        />
      </div>

      <div className='flex lg:flex-row flex-col lg:items-center gap-3'>
        <Link to="/banking-deposits">
          <Button
            operationKlassToCheckPermission="Client::Banking::Deposits::Filter"
            disabled={!hasUserPermissionToGetCompanyRemainingCreditAndBalance}
          >
            Ver Depósitos

            <SquareArrowOutUpRightIcon strokeWidth={1.5} size={18} />
          </Button>
        </Link>

        <Link to="/banking-deposits/create">
          <Button
            variant="success"
            operationKlassToCheckPermission="Client::Banking::Deposits::Create"
            disabled={!hasUserPermissionToGetCompanyRemainingCreditAndBalance}
          >
            Adicionar Saldo (Pré-pago)

            <SquareArrowOutUpRightIcon strokeWidth={1.5} size={18} />
          </Button>
        </Link>
      </div>
    </Box>
  );
}

export default CompanyBankingDepositDashboard;
